module.exports = __webpack_public_path__ + "static/media/katherine.gil-resume.fd4c3c57.pdf";